import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { PRIMARY_COLOR } from '../../../constants';
import { textStyle, linkText, buttonStyle } from '../../../helpers/getEmailStyles';

import { url } from '../../../config';

class BookingRequestHostQRPayment extends React.Component {

	static propTypes = {
		content: PropTypes.shape({
			reservationId: PropTypes.number.isRequired,
			confirmationCode: PropTypes.number.isRequired,
			hostName: PropTypes.string.isRequired,
			guestName: PropTypes.string.isRequired,
			checkIn: PropTypes.string.isRequired,
			checkOut: PropTypes.string.isRequired,
			listTitle: PropTypes.string.isRequired,
			basePrice: PropTypes.number.isRequired,
			total: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired,
			hostServiceFee: PropTypes.number.isRequired,
		}).isRequired

	};

	render() {
		const btnCenter = {
			textAlign: 'center'
		}

		const { content: { reservationId, hostName, guestName, checkIn, checkOut, logo, siteName, confirmationCode } } = this.props;
		const { content: { listTitle, basePrice, total, hostServiceFee, currency } } = this.props;
		let checkInDate = checkIn != null ? moment(checkIn).format('DD-MM-YYYY h:mm A') : '',
			checkOutDate = checkOut != null ? moment(checkOut).format('DD-MM-YYYY h:mm A') : '';
		let actionConfirmURL = url + '/process/host' + '?confirm=' + reservationId + '&code=' + confirmationCode;
		let actionDeclineURL = url + '/process/host/decline' + '?confirm=' + reservationId + '&code=' + confirmationCode;

		return (
			<Layout>
				<Header color={PRIMARY_COLOR} backgroundColor="#F7F7F7" logo={logo} siteName={siteName} />
				<div>
					<Table width="100%" >
						<TBody>
							<TR>
								<TD style={textStyle}>
									<EmptySpace height={20} />
									<div>
										Hola {hostName},
									</div>
									<EmptySpace height={20} />
									<div>
										Buenas noticias! 
									<EmptySpace height={4} />
									<div>
										Has recibido una nueva <b>solicitud de reserva</b> de <b>{guestName}</b> para tu propiedad en <b>{listTitle}</b>
									</div>
									</div>
									<EmptySpace height={20} />
									<div>
										Fechas solicitadas:
									</div>
									<EmptySpace height={4} />
									<div>
										Del {checkInDate} 
									</div>
									<EmptySpace height={4} />
									<div>
										al {checkOutDate}
									</div>
									<EmptySpace height={20} />
									<div>
										¿Qué pasa si aceptas?
									</div>
									<EmptySpace height={4} />
									<div>
										- {guestName} recibirá un código QR para pagar la comisión de {siteName} ({hostServiceFee}).
									</div>
									<EmptySpace height={4} />
									<div>
										- Una vez realizado el pago, podrán comunicarse directamente por el chat para coordinar el pago total de la estadía y todos los detalles de su llegada.
									</div>
									<EmptySpace height={4} />
									<div>
										¿Qué pasa si rechazas?
									</div>
									<EmptySpace height={4} />
									<div>
										- {guestName} será notificado(a) y podrá buscar otra propiedad.
									</div>
									<EmptySpace height={40} />
									<div style={btnCenter}>
										<a href={actionConfirmURL} style={buttonStyle}>Aceptar</a>
									</div>
									<EmptySpace height={40} />
									<div style={btnCenter}>
										<a href={actionDeclineURL} style={buttonStyle}>Rechazar</a>
									</div>
									<EmptySpace height={40} />
									<EmailSignature siteName={siteName} />
								</TD>
							</TR>
						</TBody>
					</Table>
					<EmptySpace height={40} />
				</div>
				<Footer siteName={siteName} />
				<EmptySpace height={20} />
			</Layout>
		);
	}

}

export default BookingRequestHostQRPayment;